import { useQuery } from 'react-query';
import { SERVICES_COMMISSIONS } from '../../constants/reactQuery.keys';
import { getServicesCommissions } from '../../services/Commissions';

export function useServicesCommissions() {
  return useQuery([SERVICES_COMMISSIONS], () => getServicesCommissions());
}

export { SERVICES_COMMISSIONS } from '../../constants/reactQuery.keys';
